"use strict";
exports.__esModule = true;
var methods_1 = require("./methods");
var execRegex_1 = require("./regex/execRegex");
function transformValue(value, config) {
    var trim = config.trim, regex = config.regex, type = config.type, custom = config.custom;
    var methods = config.methods;
    if (typeof value === 'string' && trim !== false) {
        value = value.trim();
    }
    if (regex) {
        value = execRegex_1["default"](value, regex);
    }
    if (Array.isArray(methods)) {
        methods.push(type);
    }
    else {
        methods = [type];
    }
    if ((methods === null || methods === void 0 ? void 0 : methods.length) > 0) {
        methods.forEach(function (name) {
            if (methods_1["default"][name]) {
                value = methods_1["default"][name](value);
            }
        });
    }
    if (typeof custom === 'function') {
        value = custom(value);
    }
    return value;
}
exports["default"] = transformValue;
